import { FC, Fragment, CSSProperties } from 'react';
import { useField } from 'formik';
import StyledErrorMessage from '../StyledErrorMessage/StyledErrorMessage';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label?: string;
  id: string;
  name: string;
  placeholder?: string;
  options: SelectOption[];
  style?: CSSProperties;
  disabled?: boolean;
}

const BStrapFormikSelect: FC<SelectProps> = ({
  label,
  placeholder,
  options,
  ...props
}) => {
  const [field, meta] = useField({ name: props.name, type: 'select' });

  return (
    <Fragment>
      {label && (
        <label htmlFor={props.id || props.name} className="form-label">
          {label}
        </label>
      )}

      <select
        className="form-select"
        {...field}
        id={props.id}
        style={props.style}
        disabled={props.disabled}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}

        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {meta.touched && meta.error && (
        <StyledErrorMessage>{meta.error}</StyledErrorMessage>
      )}
    </Fragment>
  );
};

export default BStrapFormikSelect;